import React from 'react';
import { Button } from '../ui/Button';
import { Check, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-stone-50" data-id="element-1">
      <div className="container mx-auto px-4 relative z-10" data-id="element-2">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-3">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-100 text-red-800 text-sm font-semibold mb-6" data-id="element-5">
              <span className="relative flex h-2 w-2" data-id="element-6">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-7"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-red-600" data-id="element-8"></span>
              </span>
              Sistema de 12 Semanas
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-stone-900 leading-[1.1] mb-6 tracking-tight" data-id="element-9">
              No pienses qué cocinar esta noche.{' '}
              <span className="text-red-700" data-id="element-10">Ya está decidido.</span>
            </h1>

            <p className="text-xl text-stone-600 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-11">
              Cenas latinas en 15–20 min (con lista de súper incluida). Olvídate
              de la carga mental y vuelve a comer en casa.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mb-10" data-id="element-12">
              <Button size="lg" className="w-full sm:w-auto group" onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-13">
                QUIERO MIS 12 SEMANAS LISTAS
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-14" />
              </Button>
              <p className="text-sm text-stone-500 sm:hidden" data-id="element-15">
                Oferta especial $6.39 USD
              </p>
            </div>

            <div className="flex flex-wrap justify-center lg:justify-start gap-x-6 gap-y-2 text-sm font-medium text-stone-600" data-id="element-16">
              <div className="flex items-center gap-2" data-id="element-17">
                <Check className="h-4 w-4 text-green-600" data-id="element-18" />
                <span data-id="element-19">Sin ingredientes raros</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-20">
                <Check className="h-4 w-4 text-green-600" data-id="element-21" />
                <span data-id="element-22">Usa lo que ya tienes</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-23">
                <Check className="h-4 w-4 text-green-600" data-id="element-24" />
                <span data-id="element-25">100% Digital (PDF)</span>
              </div>
            </div>
          </div>

          {/* Image/Mockup */}
          <div className="flex-1 w-full max-w-lg lg:max-w-xl relative" data-id="element-26">
            <div className="absolute -inset-4 bg-gradient-to-tr from-red-100 to-stone-100 rounded-full blur-3xl opacity-60" data-id="element-27"></div>
            <img src="https://cdn.magicpatterns.com/uploads/3N5wtoULcRrLWijbDc6Psh/no_pienses_cocina_mockup.png" alt="Listo Pa' Cenar en iPad" className="relative w-full h-auto drop-shadow-2xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-28" />
          </div>
        </div>
      </div>
    </section>;
}